import { useQuery } from '@tanstack/react-query'
import { productsApi } from '@/api/endpoints/products'

export function useProductDetail(sku: string) {
  return useQuery({
    queryKey: ['products', sku],
    queryFn: () => productsApi.get(sku),
    enabled: !!sku,
  })
}
